import GridViewCollapase from "src/SharedComponents/GridViewCollapse/GridViewCollapse";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import { IAuraSoftwareSuiteLicensesInfo } from "src/Utils/Hooks/useGetDistributorInfo/useGetDistributorInfo";
import { formatDateString } from "src/Utils/DateFormatting/DateFormattter";
import { getLicenseType } from "src/Utils/Hooks/useGetDistributorInfo/LicenseTypeHelper";
import { useTranslation } from "react-i18next";
import { isDateExpired } from "src/Utils/DateExpiry/DateExpiryChecker";

export interface IAuraSoftwareSuitesLicensesAssigned{
    auraSoftwareSuitesLicensesAssigned: IAuraSoftwareSuiteLicensesInfo[];
    distributorId: string;
}

const AuraSoftwareSuitesAssigned: React.FC<IAuraSoftwareSuitesLicensesAssigned> = ({auraSoftwareSuitesLicensesAssigned}) => {
    const {t} = useTranslation();
    
    return(
        <>
            <GridViewCollapase title={t('Assigned')} id="aura-software-suites-licenses-assigned">
                <div>
                    <table style={{ width: '100%' }} data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                        <thead className={`${tableStyles.tableHead}`}>
                            <tr key={'header'}>
                                
                                <th className={tableStyles.heading} style={{width: '10%', paddingTop: '0px', paddingLeft: '25px'}}>{t('Suite')}</th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>{t('SignUpDate')}</th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>{t('ExpirationDate')}</th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>{t('AssignedTo')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                auraSoftwareSuitesLicensesAssigned && auraSoftwareSuitesLicensesAssigned.map((license: IAuraSoftwareSuiteLicensesInfo, index: number) => (
                                    <tr key={index}>
                                        <td className={`${tableStyles.data} ${tableStyles.suiteValue}`} style={{paddingLeft: '25px'}}>{getLicenseType(license?.licenseType)}</td>
                                        <td className={tableStyles.data}>{formatDateString(license?.activationDate)}</td>
                                        <td className={tableStyles.data} style={isDateExpired(license?.licenseEndDate) ? {color: 'red'} : {}}>{license?.licenseEndDate ? formatDateString(license?.licenseEndDate) : '-'}</td>
                                        <td className={tableStyles.data}>{license?.clinicName}</td>
                                        <td></td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </GridViewCollapase>
        </>
    );
}

export default AuraSoftwareSuitesAssigned;